import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Menu } from '@fiverr-private/orca';
import If from '../../../../lib/If';
import { rollouts, user } from '../../../../PropTypes';
import {
    SellerPromotedGigsLink,
    SellerBusinessLink,
    SellerByobLink,
    SellerContactsLink,
    KickstartProgramPageLink,
    SellerPlusLink,
    SellerMarketingToolsLink,
    SellerSPForumLink,
} from '../../../SellerLinks';
import SellerDropdown from '../../SellerDropdown';
import SellerAchievementsLink from '../../Links/SellerOverview';
import TeamAccountsLink from '../../Links/TeamAccounts';
import { SellerReferralsLink } from '../../Links/SellerReferrals';
import { KICKSTART_STATUS, SELLER_PLUS_STATUS, SELLER_PLUS_TIER } from '../../../../constants';
import GroupHeader from '../GroupHeader';

const GrowthAndMarketing = (props, { user, rollouts }) => {
    const isSellerPlusEligible = user.sellerPlus?.status === SELLER_PLUS_STATUS.ELIGIBLE;
    const isSellerPlusEnrolled = user.sellerPlus?.status === SELLER_PLUS_STATUS.ENROLLED;
    const isPremium = user.sellerPlus?.tier === SELLER_PLUS_TIER.PREMIUM;
    const sellerPlusLabelKey = !isSellerPlusEnrolled ? 'header.link_label.program_benefits' : undefined; // Use default
    const isEligibleToKickstartProgram = user.kickstart?.status === KICKSTART_STATUS.ELIGIBLE;
    const isEnrolledToKickstartProgram = user.kickstart?.status === KICKSTART_STATUS.ENROLLED;
    const inFalconsTeamAccountRollout = rollouts.inFalconsTeamAccount;
    const inDragonsSellerReferralsDashboardRollout = rollouts.inDragonsSellerReferralsDashboardRollout;
    const inDragonsSellerReferralsFlowRollout = rollouts.inDragonsSellerReferralsFlowRollout;

    const isATeamOwnerOrNotEnrolled = user.teamAccount?.ownerId === user.id || !user.teamAccount;
    const kickstartProgramPageLabelKey = isEnrolledToKickstartProgram
        ? 'header.program_page'
        : 'header.link_label.program_benefits';

    return (
        <SellerDropdown
            triggerLabel={<I18n k="header.submenu.growth_and_marketing" />}
            menu={
                <Menu className="seller-menu">
                    {/* Seller plus program section */}
                    <If condition={(isSellerPlusEligible && !isEnrolledToKickstartProgram) || isSellerPlusEnrolled}>
                        <GroupHeader labelKey="header.seller_plus" />
                        <Menu.Item>
                            <SellerPlusLink labelKey={sellerPlusLabelKey} sellerId={user.id} />
                        </Menu.Item>
                        <If condition={isSellerPlusEnrolled}>
                            <Menu.Item>
                                <SellerMarketingToolsLink sellerId={user.id} />
                            </Menu.Item>
                        </If>
                        <If condition={isSellerPlusEnrolled && isPremium}>
                            <Menu.Item>
                                <SellerSPForumLink sellerId={user.id} />
                            </Menu.Item>
                        </If>
                        <Menu.Divider />
                    </If>
                    {/* Kickstart program section */}
                    <If
                        condition={
                            (isEligibleToKickstartProgram && !isSellerPlusEligible) || isEnrolledToKickstartProgram
                        }
                    >
                        <GroupHeader labelKey="header.kickstart" />
                        <Menu.Item>
                            <KickstartProgramPageLink labelKey={kickstartProgramPageLabelKey} sellerId={user.id} />
                        </Menu.Item>
                        <Menu.Divider />
                    </If>
                    <If condition={!!user.promotedAdsVisible}>
                        <Menu.Item>
                            <SellerPromotedGigsLink sellerId={user.id} sellerUsername={user.username} />
                        </Menu.Item>
                    </If>
                    <If condition={!!user.isPro}>
                        <Menu.Item>
                            <SellerBusinessLink sellerId={user.id} />
                        </Menu.Item>
                    </If>
                    <Menu.Item>
                        <SellerAchievementsLink sellerId={user.id} />
                    </Menu.Item>
                    <If condition={inFalconsTeamAccountRollout && isATeamOwnerOrNotEnrolled}>
                        <Menu.Item>
                            <TeamAccountsLink teamSlug={user.teamAccount?.slug} />
                        </Menu.Item>
                    </If>
                    <If condition={inDragonsSellerReferralsDashboardRollout && inDragonsSellerReferralsFlowRollout}>
                        <Menu.Item>
                            <SellerReferralsLink />
                        </Menu.Item>
                    </If>
                    <If condition={!!user.businessOfferEnrollment}>
                        <Menu.Item>
                            <SellerByobLink sellerId={user.id} sellerUsername={user.username} hasTag={false} />
                        </Menu.Item>
                    </If>
                    <Menu.Item>
                        <SellerContactsLink sellerId={user.id} />
                    </Menu.Item>
                </Menu>
            }
        />
    );
};

GrowthAndMarketing.contextTypes = {
    user,
    rollouts,
};

export default GrowthAndMarketing;
